import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import CarBookingModal from "../../../common/modal/carBookingModal";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../../core/data/img/ImageWithBasePath";
import { all_routes } from "../../../../router/all_routes";
import { DatePicker } from "antd";
import dayjs from 'dayjs';
import CarMasterValue from "./carMasterValue";
import { CreateCarData, generateSlug, ListMasterData, S3CDNURL, uploadFileAPI } from "../../../../../functionsMaster";
import VideoModal from "../../../common/modal/videoModal";

const AddCarForm = ({
  formData,
  setFormData,
  defaultFormData,
  message,
  setMessage,
  filtersCars
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const videoUrl = "https://www.youtube.com/embed/1trvO6dqQUI";

  const handleCloseModal = () => setShowModal(false);
  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
  };

  async function saveCarData(e: any) {
    e.preventDefault();
    const sendData = { ...formData, pricing: updatedPackages };
    try {
      setMessage((prev) => ({ ...prev, loader: true }));
      const temp = await CreateCarData(sendData , message.editID);
      // Optionally handle the response `temp` here if needed
      // Example: if (temp.status === 1) { ... }
      setMessage((prev) => ({ ...prev, ...temp, loader: false, editID: temp.editID }));
    } catch (error) {
      console.error('Error saving car data:', error);
      setMessage((prev) => ({ ...prev, loader: false }));
    }
    // alert(formData.exit);
    if (formData.exit) {
      setFormData(defaultFormData);
      filtersCars();
    }
    return true;
  }

  async function uploadFile(e, file) {
      e.preventDefault();
      setFormData({ ...formData, apiCall: true });
      try {
          const data = await uploadFileAPI(file, 'carPhoto');
          if (data && data.file && data.file !== 0) {
              setFormData({ ...formData, apiCall: false, image: data.file});
          } else {
              alert(data.message);
              setFormData({ ...formData, apiCall: false});
          }
      } catch (e) {
          alert(e.message);
          setFormData({ ...formData, apiCall: false});
      }
  }

  function setCarMasterValue(i = '', v = '') {
    setFormData({ ...formData, [i]: v });
  }
  const [carCategory, setCarCategory] = useState([]); // temp
  const [carBrand, setCarBrand] = useState([]); // temp1
  const [carModel, setCarModel] = useState([]); // temp2
  const [carColor, setCarColor] = useState([]); // temp3
  const [carSeat, setCarSeat] = useState([]); // temp4
  const [carFuel, setCarFuel] = useState([]); // temp5
  const [carDoor, setCarDoor] = useState([]); // temp6
  const [carCylinder, setCylinder] = useState([]); // temp7
  const [carTransmission, setCarTransmission] = useState([]); // temp8
  const [carSteering, setCarSteering] = useState([]); // temp9
  const [carFeatures, setCarFeatures] = useState([]); // temp10
  const [carSafetyFeatures, setCarSafetyFeatures] = useState([]); // temp11

  const [branchLocation, setBranchLocation] = useState([]); // temp12
  const [carsPackages, setCarsPackages] = useState([]); // temp13

  const [updatedPackages, setUpdatedPackages] = useState(formData.pricing); // temp13

  const handleRateChange = (pkgID, field, value, index) => {
    const temp = updatedPackages;
    if (!temp[index]) {
      temp[index] = {};
    }
    temp[index] = { ...temp[index], _id: index, [field]: value, pkgID }
    setUpdatedPackages(temp);
  };



useEffect(() => {
  const CACHE_DURATION = 60 * 1000; // 4 hours in milliseconds

  const fetchData = async () => {    
    const temp = await ListMasterData('carsPackages', { status: 1 });
    setCarsPackages(temp.data && temp.data.length > 0 ? temp.data : []);

    const config = [
      { key: 'carCategory', setter: setCarCategory },
      { key: 'carBrand', setter: setCarBrand },
      { key: 'carModel', setter: setCarModel },
      { key: 'carColor', setter: setCarColor },
      { key: 'carSeat', setter: setCarSeat },
      { key: 'carFuel', setter: setCarFuel },
      { key: 'carDoor', setter: setCarDoor },
      { key: 'carCylinder', setter: setCylinder },
      { key: 'carTransmission', setter: setCarTransmission },
      { key: 'carSteering', setter: setCarSteering },
      { key: 'carFeatures', setter: setCarFeatures },
      { key: 'carSafetyFeatures', setter: setCarSafetyFeatures },
      { key: 'branchLocation', setter: setBranchLocation },
    ];

    await Promise.all(
      config.map(async ({ key, setter }) => {
        const cacheKey = `masterData_${key}`;
        const cacheRaw = localStorage.getItem(cacheKey);

        if (cacheRaw) {
          const { timestamp, data } = JSON.parse(cacheRaw);
          const isExpired = Date.now() - timestamp > CACHE_DURATION;

          if (!isExpired && Array.isArray(data)) {
            setter(data);
            return;
          }
        }

        // Fetch from API if not cached or expired
        try {
          const res = await ListMasterData(key, { status: 1, limitedData: 'Yes' });
          const data = Array.isArray(res.data) ? res.data : [];
          setter(data);
          if (data && data.length > 0) {
            localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data }));
          }
        } catch (err) {
          console.error(`Failed to fetch ${key}`, err);
          setter([]);
        }
      })
    );
  };

  fetchData();
}, []);

  function rateOfPackage(pkgID, field) {
    let item = {};
    if (pkgID) {
      item = updatedPackages.find(pkg => pkg && pkg.pkgID && pkg.pkgID === pkgID);
    }
    return item && item[field] ? item[field] : '';
  }

  function updateCarTitle() {
    let temp1 = carBrand.find(item => item._id === formData.brand);
    temp1 = temp1 ? temp1.title : "";
    let temp2 = carModel.find(item => item._id === formData.model);
    temp2 = temp2 ? temp2.title : "";
    if (temp1 && temp2) {
      setFormData({ ...formData, name: `${temp1} ${temp2}` });
    }
  }

  return (
    <>
      <div className="content me-0">
        <div className="mb-3">
          <Link
            to={all_routes.adminCarsList}
            onClick={(e) => {
              e.preventDefault();
              setFormData(defaultFormData);
              filtersCars();
            }}
            className="d-inline-flex align-items-center fw-medium"
          >
            <i className="ti ti-arrow-left me-1" />
            Back to List
          </Link>
        </div>
        <div className="card mb-0">
          <div className="card-body">
            <div className="add-wizard car-steps">
              <ul className="nav d-flex align-items-center flex-wrap gap-3">
                <li
                  className={`nav-item ${
                    currentStep === 1
                      ? "active"
                      : currentStep > 1
                        ? "activated"
                        : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="nav-link d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(1);
                    }}
                  >
                    <i className="ti ti-info-circle me-1" />
                    Basic
                  </Link>
                </li>
                <li
                  className={`nav-item ${
                    currentStep === 2
                      ? "active"
                      : currentStep > 2
                        ? "activated"
                        : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="nav-link d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(2);
                    }}
                  >
                    <i className="ti ti-flame me-1" />
                    Features
                  </Link>
                </li>
                <li
                  className={`nav-item ${
                    currentStep === 3
                      ? "active"
                      : currentStep > 3
                        ? "activated"
                        : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="nav-link d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(3);
                    }}
                  >
                    <i className="ti ti-files me-1" />
                    Pricing
                  </Link>
                </li>

                <li
                  className={`nav-item ${
                    currentStep === 4
                      ? "active"
                      : currentStep > 4
                        ? "activated"
                        : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="nav-link d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(4);
                    }}
                  >
                    <i className="ti ti-file-invoice me-1" />
                    Uploads
                  </Link>
                </li>
                <li
                  className={`nav-item ${
                    currentStep === 5
                      ? "active"
                      : currentStep > 5
                        ? "activated"
                        : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="nav-link d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(5);
                    }}
                  >
                    <i className="ti ti-id me-1" />
                    Damages
                  </Link>
                </li>
                <li
                  className={`nav-item ${
                    currentStep === 6
                      ? "active"
                      : currentStep > 6
                        ? "activated"
                        : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="nav-link d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(6);
                    }}
                  >
                    <i className="ti ti-question-mark me-1" />
                    FAQ
                  </Link>
                </li>
                <li
                  className={`nav-item ${
                    currentStep === 7
                      ? "active"
                      : currentStep > 7
                        ? "activated"
                        : ""
                  }`}
                >
                  <Link
                    to="#"
                    className="nav-link d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentStep(7);
                    }}
                  >
                    <i className="ti ti-seo me-1" />
                    SEO
                  </Link>
                </li>
              </ul>
              {currentStep === 1 && (
                <fieldset id="first-field">
                  <form
                    action="/"
                    onSubmit={async(e) => {
                      await saveCarData(e);
                    }}
                  >
                    <div className="filterbox p-20 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <h4 className="d-flex align-items-center">
                        <i className="ti ti-info-circle text-secondary me-2" />
                        Basic Info
                      </h4>
                    </div>
                    <div className="border-bottom mb-4 pb-4">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          <h6 className="mb-1">Featured Image</h6>
                          <p>Upload Featured Image</p>
                        </div>
                        <div className="col-xl-9">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 upload-pic">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl me-3 flex-shrink-0 border rounded-circle frames">
                              <img
                                src={`${S3CDNURL}${formData.image}`}
                                className="img-fluid rounded-circle"
                                alt="Car Photo"
                              />
                              {/* <Link
                                to="#"
                                className="upload-img-trash trash-end btn btn-sm rounded-circle"
                              >
                                <i className="ti ti-trash fs-12" />
                              </Link> */}
                            </div>
                            <div>
                              <div className="drag-upload-btn btn btn-md btn-dark d-inline-flex align-items-center mb-2">
                                <i className="ti ti-photo me-1" />
                                Change
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  onChange={(e) => {
                                      if (e.target.files) {
                                        // alert(1);
                                        uploadFile(e, e.target.files[0]);
                                      } else {
                                        // alert(2);
                                      }
                                  }}
                                />
                              </div>
                              <p>Recommended size is 500px x 500px</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-bottom mb-2 pb-2">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          {/* <h6 className="mb-1">Car Info</h6>
                          <p>Add Information About Car</p> */}



                          <div className="mb-3">
                            <label className="form-label">Status</label>
                            <select
                              name="status"
                              value={formData.status}
                              className="form-control"
                              onChange={(e) => {
                                setFormData({ ...formData, [e.target.name]: e.target.value });
                              }}
                              required
                            >
                              <option value="">Select Status</option>
                              <option value="1">Active</option>
                              <option value="0">Inactive</option>
                            </select>
                          </div>

                          <label className="form-label">Description</label>
                          <textarea
                              name="description"
                              value={formData.description}
                              className="form-control"
                              rows={10}
                              onChange={(e) => {
                                setFormData({ ...formData, [e.target.name]: e.target.value });
                              }}
                            />
                        </div>
                        <div className="col-xl-9">

                                  
                          <div className="row">
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/types"
                                    type="category"
                                    value={formData.category}
                                    setValue={setCarMasterValue}
                                    arrayData={carCategory}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                  addLink="/admin/brands"
                                  type="brand"
                                  value={formData.brand}
                                  setValue={setCarMasterValue}
                                  arrayData={carBrand}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/models"
                                    type="model"
                                    value={formData.model}
                                    setValue={setCarMasterValue}
                                    arrayData={carModel}
                                  />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="form-label d-block">
                              Name <span className="text-danger">*</span>
                              <a
                                href="/"
                                style={{ float: "right" }}
                                className="text-warning"
                                onClick={(e) => {
                                  e.preventDefault();
                                  updateCarTitle();
                                }}
                              >
                                Update Name from Brand & Model
                              </a>
                              <div style={{ clear: "both" }}></div>
                            </label>
                            <input
                              type="text"
                              name="name"
                              className="form-control"
                              value={formData.name}
                              onClick={(e) => {
                                if (!e.target.value) {
                                  updateCarTitle();
                                }
                              }}
                              onChange={(e) => {
                                setFormData({ ...formData, [e.target.name]: e.target.value });
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Permalink</label>
                            <input
                              type="text"
                              name="slug"
                              value={formData.slug}
                              defaultValue={formData.name ? generateSlug(formData.name) : formData.slug}
                              className="form-control"
                              onChange={() => {
                                const temp = generateSlug(e.target.value);
                                setFormData({ ...formData, [e.target.name]: temp });
                              }}
                            />
                            <p className="fs-13 fw-medium mt-1">
                              Preview :{" "}
                              <Link to="#" className="link-info">
                                https://www.example.com/cars/${formData.slug}
                              </Link>
                            </p>
                          </div>

                          <div className="row">

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/color"
                                    type="color"
                                    value={formData.color}
                                    setValue={setCarMasterValue}
                                    arrayData={carColor}
                                  />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/seats"
                                    type="seat"
                                    value={formData.seat}
                                    setValue={setCarMasterValue}
                                    arrayData={carSeat}
                                  />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/fuel"
                                    type="fuel"
                                    value={formData.fuel}
                                    setValue={setCarMasterValue}
                                    arrayData={carFuel}
                                  />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/door"
                                    type="door"
                                    value={formData.door}
                                    setValue={setCarMasterValue}
                                    arrayData={carDoor}
                                  />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/cylinder"
                                    type="cylinder"
                                    value={formData.cylinder}
                                    setValue={setCarMasterValue}
                                    arrayData={carCylinder}
                                  />
                              </div>
                            </div>

                            
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/transmission"
                                    type="transmission"
                                    value={formData.transmission}
                                    setValue={setCarMasterValue}
                                    arrayData={carTransmission}
                                  />
                              </div>
                            </div>
                            
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                    addLink="/admin/steering"
                                    type="steering"
                                    value={formData.steering}
                                    setValue={setCarMasterValue}
                                    arrayData={carSteering}
                                  />
                              </div>
                            </div>
                            
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Plate Number
                                </label>
                                <input
                                  type="text"
                                  name="plateNumber"
                                  value={formData.plateNumber}
                                  className="form-control"
                                  onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                  }}
                                />
                              </div>
                            </div>
                            
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <CarMasterValue
                                  addLink="/admin/locations"
                                  type="branch"
                                  value={formData.branch}
                                  setValue={setCarMasterValue}
                                  arrayData={branchLocation}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Odometer</label>
                                <input
                                  type="number"
                                  name="odometer"
                                  value={formData.odometer}
                                  className="form-control"
                                  onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Year of Car{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="input-icon-end position-relative">
                                  <DatePicker
                                    picker="year"
                                    className="form-control datetimepicker"
                                    placeholder="yyyy"
                                    value={formData.year ? dayjs(`${formData.year}`, "YYYY") : null}
                                    onChange={(value, year) => {
                                      // If you want to save it:
                                      setFormData({ ...formData, year: Number(year) });
                                    }}
                                  />
                                  <span className="input-icon-addon">
                                    <i className="ti ti-calendar" />
                                  </span>
                                </div>
                              </div>
                            </div>
                            
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Mileage</label>
                                <input
                                  type="number"
                                  name="mileage"
                                  value={formData.mileage}
                                  className="form-control"
                                  onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Passengers</label>
                                <input
                                  type="number"
                                  name="passengers"
                                  value={formData.passengers}
                                  className="form-control"
                                  onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                  }}
                                />
                              </div>
                            </div>
                            
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  No of Air Bags
                                </label>
                                <input
                                  type="number"
                                  name="airBags"
                                  value={formData.airBags}
                                  className="form-control"
                                  onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {message && message.message && message.message !== "" && (
                      <div className={`alert alert-${message.status === 1 ? 'success' : 'danger'}`}>{message.message}</div>
                    )}
                    {message.loader && (<div className="text-center"><img src="/loader.gif" style={{ maxWidth: '45px' }} alt="" /></div>)}
                    <div className="d-flex align-items-center justify-content-end pt-3">
                      <button
                        type="button"
                        className="btn btn-light d-flex align-items-center me-2"
                         onClick={(e) => {
                            e.preventDefault();
                            setFormData(defaultFormData);
                            filtersCars();
                          }}
                      >
                        <i className="ti ti-chevron-left me-1" />
                        Back
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success wizard-next d-flex align-items-center me-2"
                      >
                        Save
                        <i className="ti ti-save me-1" />
                      </button>
                      <button
                        className="btn btn-primary wizard-next d-flex align-items-center"
                        type="button"
                        onClick={handleNext}
                      >
                        Add Features
                        <i className="ti ti-chevron-right ms-1" />
                      </button>
                    </div>
                  </form>
                </fieldset>
              )}
              {currentStep === 2 && (
                <fieldset style={{ display: "block" }}>
                  <form action="#">
                    <div className="filterbox p-20 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <h4 className="d-flex align-items-center">
                        <i className="ti ti-flame text-secondary me-2" />
                        Features &amp; Amenities
                      </h4>
                    </div>
                    <div className="border-bottom mb-2 pb-2 amenity-wrap">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          <h6 className="mb-1">Features &amp; Amenities</h6>
                          <p>Add Information About Car</p>
                        </div>
                        <div className="col-xl-9">
                          <div className="row">
                            {/* <div className="col-lg-12">
                              <div className="mb-3">
                                <div className="form-check mb-0">
                                  <input
                                    className="form-check-input select-all"
                                    type="checkbox"
                                    id="select-all1"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity"
                                  >
                                    Check All
                                  </label>
                                </div>
                              </div>
                            </div> */}
                            <div style={{ display: 'none' }}>
                              {carFeatures && carFeatures.map((s) => (
                                <div key={s._id}>####: {s.title}</div>
                              ))}
                              {carSafetyFeatures && carSafetyFeatures.map((s) => (
                                <div key={s._id}>####: {s.title}</div>
                              ))}
                            </div>

                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity"
                                  >
                                    Air Condition
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity1"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity1"
                                  >
                                    Climate Control
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity2"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity2"
                                  >
                                    Climate Control Two Zones
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity3"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity3"
                                  >
                                    Luxury Climate Control
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity4"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity4"
                                  >
                                    Sunroof
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity5"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity5"
                                  >
                                    Panoramic Sunroof
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity6"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity6"
                                  >
                                    Moonroof
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity7"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity7"
                                  >
                                    Push-button Start
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity8"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity8"
                                  >
                                    Keyless Access
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity9"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity9"
                                  >
                                    Rear Parking Sensors
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity10"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity10"
                                  >
                                    Parking Sensors
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity11"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity11"
                                  >
                                    Built-in Sat Nav
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity12"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity12"
                                  >
                                    Mobile Phone Technology
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity13"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity13"
                                  >
                                    Bluetooth
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity14"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity14"
                                  >
                                    Usb
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity15"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity15"
                                  >
                                    Qi Wireless Charging
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity16"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity16"
                                  >
                                    Audio/ipod
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity17"
                                    defaultChecked
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity17"
                                  >
                                    Cruise Control
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity18"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity18"
                                  >
                                    Adaptive Cruise Control
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity19"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity19"
                                  >
                                    Apple Carplay
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity20"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity20"
                                  >
                                    Android Auto
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity21"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity21"
                                  >
                                    Forward Collision Warning
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity22"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity22"
                                  >
                                    Lane Departure Warning
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity23"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity23"
                                  >
                                    Automatic Emergency Braking
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity24"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity24"
                                  >
                                    Active Parking Assist
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity25"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity25"
                                  >
                                    Automatic High Beams
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity26"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity26"
                                  >
                                    Adaptive Headlights
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity27"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity27"
                                  >
                                    360-degree Camera
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity29"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity29"
                                  >
                                    Rearview Camera
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity30"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity30"
                                  >
                                    Towing Hook
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity31"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity31"
                                  >
                                    Leather Interior
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="mb-3">
                                <div className="form-check form-checkbox mb-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="amenity32"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="amenity32"
                                  >
                                    Fabric Interior
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end pt-3">
                      <button
                        type="button"
                        className="btn btn-outline-light border wizard-prev me-2"
                        onClick={handlePrev}
                      >
                        <i className="ti ti-chevron-left me-1" />
                        Back
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success wizard-next d-flex align-items-center me-2"
                      >
                        Save
                        <i className="ti ti-save me-1" />
                      </button>
                      <button
                        type="button"
                        onClick={handleNext}
                        className="btn btn-primary wizard-next d-flex align-items-center"
                      >
                        Add Rental Pricing
                        <i className="ti ti-chevron-right ms-1" />
                      </button>
                    </div>
                  </form>
                </fieldset>
              )}
              {currentStep === 3 && (
                <fieldset style={{ display: "block" }}>
                  <form
                    action="/"
                    onSubmit={async(e) => {
                      await saveCarData(e);
                    }}
                  >
                    <div className="filterbox p-20 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <h4 className="d-flex align-items-center">
                        <i className="ti ti-files text-secondary me-2" />
                        Rental Pricing
                      </h4>
                    </div>
                    
                    <div className="form-checkbox mb-5">
                      <div className="row row-gap-4">
                        {/* <div className="col-xl-3"  */}
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label">Local Drive Charge</label>
                              <input
                                type="number"
                                name="localDriveRate"
                                className="form-control mb-3"
                                defaultValue="5000" 
                                onChange={(e) => setFormData({ ...formData, localDriveRate: e.target.value })}
                              />
                          </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label">Local Drive Charge</label>
                              <input
                                type="number"
                                name="outstaionDriveRate"
                                className="form-control mb-3"
                                defaultValue="7000" 
                                onChange={(e) => setFormData({ ...formData, outstaionDriveRate: e.target.value })}
                              />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border-bottom mb-4 pb-2 unlimited-price">
                      <div className="row row-gap-4">
                        {/* <div className="col-xl-3"  */}
                        <div className="col-xl-12">
                           {carsPackages && carsPackages.map((s, index) => (
                              <div key={s._id} className="form-checkbox mb-5">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h6>
                                      {s.title}&nbsp;
                                      <small className="">
                                        ({s.fuel ? "With Fuel" : "Without Fuel"})
                                      </small>
                                    </h6>
                                    <div className="mb-2 text-warning">
                                        {s.distance ? `${s.distance} KM/ Hour` : 'Unlimited KM'}
                                    </div>
                                  </div>
                                  <hr
                                    style={{
                                        margin: '10px',
                                        borderBottom: '1px solid #dedede',
                                        opacity: 1
                                    }} 
                                  />
                                  <div className="row">
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label className="form-label">Base Rate (0 to 12 Hour)</label>
                                          <input
                                            type="number"
                                            name={`baseRate${s._id}`}
                                            className="form-control"
                                            defaultValue={rateOfPackage(s._id, 'baseRate')}
                                            onChange={(e) => handleRateChange(s._id, 'baseRate', e.target.value, index)}
                                          />
                                        </div>
                                      </div>
                                      
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label className="form-label">Hourly Rate (13 Hours and Above)</label>
                                          <input
                                            type="number"
                                            name={`hourlyRate${s._id}`}
                                            className="form-control"
                                            defaultValue={rateOfPackage(s._id, 'hourlyRate')}
                                            onChange={(e) => handleRateChange(s._id, 'hourlyRate', e.target.value, index)}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label className="form-label">Extra per KM Charge</label>
                                          <input
                                            type="number"
                                            name={`extraKMRate${s._id}`}
                                            className="form-control"
                                            defaultValue={rateOfPackage(s._id, 'extraKMRate')}
                                            onChange={(e) => handleRateChange(s._id, 'extraKMRate', e.target.value, index)}
                                          />
                                        </div>
                                      </div>
                                  </div>
                                  &nbsp;
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>

                    {message && message.message && message.message !== "" && (
                      <div className={`alert alert-${message.status === 1 ? 'success' : 'danger'}`}>{message.message}</div>
                    )}
                    {message.loader && (<div className="text-center"><img src="/loader.gif" style={{ maxWidth: '45px' }} alt="" /></div>)}

                    <div className="d-flex align-items-center justify-content-end pt-3">
                      <button
                        type="button"
                        className="btn btn-outline-light border wizard-prev me-2"
                        onClick={handlePrev}
                      >
                        <i className="ti ti-chevron-left me-1" />
                        Back
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success wizard-next d-flex align-items-center me-2"
                      >
                        Save
                        <i className="ti ti-save me-1" />
                      </button>
                      <button
                        type="button"
                        onClick={handleNext}
                        className="btn btn-primary wizard-next d-flex align-items-center"
                      >
                        Add Documents
                        <i className="ti ti-chevron-right ms-1" />
                      </button>
                    </div>
                  </form>
                </fieldset>
              )}
              
              {currentStep === 4 && (
                <fieldset style={{ display: "block" }}>
                  <form>
                    <div className="filterbox p-20 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <h4 className="d-flex align-items-center">
                        <i className="ti ti-file-invoice text-secondary me-2" />
                        Documents
                      </h4>
                      <div className="dropdown flag-dropdown">
                        <Link
                          className="dropdown-toggle btn btn-white d-flex align-items-center justify-content-between"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          <ImageWithBasePath
                            src="assets/admin/img/flags/gb.svg"
                            alt="Language"
                            className="img-fluid me-1"
                          />
                          English
                        </Link>
                        <ul className="dropdown-menu p-2">
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item d-flex align-items-center"
                            >
                              <ImageWithBasePath
                                src="assets/admin/img/flags/gb.svg"
                                alt=""
                                height={16}
                                className="me-1"
                              />
                              English
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item d-flex align-items-center"
                            >
                              <ImageWithBasePath
                                src="assets/admin/img/flags/sa.svg"
                                alt=""
                                height={16}
                                className="me-1"
                              />
                              Arabic
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="border-bottom mb-4 pb-3">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          <h6 className="mb-1">Car Documents</h6>
                          <p>Add Important Documents of your Car</p>
                        </div>
                        <div className="col-xl-9">
                          <div className="row">
                            <div className="col-xxl-8 col-lg-10">
                              <h6 className="mb-3">Upload Document</h6>
                              <div className="document-upload text-center bg-light br-5 mb-3">
                                <ImageWithBasePath
                                  src="assets/admin/img/icons/upload-icon.svg"
                                  alt="img"
                                  className="mb-2"
                                />
                                <p className="mb-2">
                                  Drop your files here or{" "}
                                  <span className="text-info text-decoration-underline">
                                    Browse
                                  </span>
                                </p>
                                <p className="fs-12 mb-0">Maximum size 50mb</p>
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  multiple
                                  accept=".pdf, .txt, .doc, .docx"
                                />
                              </div>
                              <div className="mb-3">
                                <p className="fs-13 mb-1">
                                  Upload Insurance, Car Registration, Documents
                                </p>
                                <p className="fs-13">Formats PDF, Word</p>
                              </div>
                              <div className="d-flex align-items-center justify-content-between bg-white border br-5 gap-3 flex-wrap p-20 mb-2">
                                <div className="d-flex align-items-center">
                                  <span>
                                    <ImageWithBasePath
                                      src="assets/admin/img/icons/pdf-icon.svg"
                                      alt="img"
                                    />
                                  </span>
                                  <div className="ms-2">
                                    <h6 className="fs-14 fw-medium">
                                      Insurance_car3546
                                    </h6>
                                    <p className="fs-13">24.45 KB</p>
                                  </div>
                                </div>
                                <div className="progress-wrap">
                                  <div
                                    className="progress progress-sm"
                                    role="progressbar"
                                    aria-valuenow={25}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  >
                                    <div
                                      className="progress-bar bg-success"
                                      style={{ width: "25%" }}
                                    />
                                  </div>
                                </div>
                                <div className="icon-list">
                                  <Link to="#" className="trash-icon">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between bg-white border br-5 gap-3 flex-wrap p-20 mb-2">
                                <div className="d-flex align-items-center">
                                  <span>
                                    <ImageWithBasePath
                                      src="assets/admin/img/icons/pdf-icon.svg"
                                      alt="img"
                                    />
                                  </span>
                                  <div className="ms-2">
                                    <h6 className="fs-14 fw-medium">
                                      Reg_car3546
                                    </h6>
                                    <p className="fs-13">20.45 KB</p>
                                  </div>
                                </div>
                                <div className="progress-wrap d-none">
                                  <div
                                    className="progress"
                                    role="progressbar"
                                    aria-valuenow={25}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  >
                                    <div
                                      className="progress-bar bg-success"
                                      style={{ width: "25%" }}
                                    />
                                  </div>
                                </div>
                                <div className="icon-list">
                                  <Link to="#" className="trash-icon">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-bottom mb-4 pb-3">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          <h6 className="mb-1">Policies</h6>
                          <p>Add policies of your Car</p>
                        </div>
                        <div className="col-xl-9">
                          <div className="row">
                            <div className="col-xxl-8 col-lg-10">
                              <h6 className="mb-3">Upload Document</h6>
                              <div className="document-upload text-center bg-light br-5 mb-3">
                                <ImageWithBasePath
                                  src="assets/admin/img/icons/upload-icon.svg"
                                  alt="img"
                                  className="mb-2"
                                />
                                <p className="mb-2">
                                  Drop your files here or{" "}
                                  <span className="text-info text-decoration-underline">
                                    Browse
                                  </span>
                                </p>
                                <p className="fs-12 mb-0">Maximum size 50mb</p>
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  multiple
                                  accept=".pdf, .txt, .doc, .docx"
                                />
                              </div>
                              <div className="mb-3">
                                <p className="fs-13 mb-1">
                                  Upload Car Policy Documents
                                </p>
                                <p className="fs-13">Formats PDF, Word</p>
                              </div>
                              <div className="d-flex align-items-center justify-content-between bg-white border br-5 gap-3 flex-wrap p-20 mb-2">
                                <div className="d-flex align-items-center">
                                  <span>
                                    <ImageWithBasePath
                                      src="assets/admin/img/icons/pdf-icon.svg"
                                      alt="img"
                                    />
                                  </span>
                                  <div className="ms-2">
                                    <h6 className="fs-14 fw-medium">
                                      Insurance_car3546
                                    </h6>
                                    <p className="fs-13">24.45 KB</p>
                                  </div>
                                </div>
                                <div className="progress-wrap">
                                  <div
                                    className="progress progress-sm"
                                    role="progressbar"
                                    aria-valuenow={25}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  >
                                    <div
                                      className="progress-bar bg-success"
                                      style={{ width: "25%" }}
                                    />
                                  </div>
                                </div>
                                <div className="icon-list">
                                  <Link to="#" className="trash-icon">
                                    <i className="ti ti-trash" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end pt-3">
                      <button
                        type="button"
                        onClick={handlePrev}
                        className="btn btn-outline-light border wizard-prev me-2"
                      >
                        <i className="ti ti-chevron-left me-1" />
                        Back
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success wizard-next d-flex align-items-center me-2"
                      >
                        Save
                        <i className="ti ti-save me-1" />
                      </button>
                      <button
                        type="button"
                        onClick={handleNext}
                        className="btn btn-primary wizard-next d-flex align-items-center"
                      >
                        Add Damage
                        <i className="ti ti-chevron-right ms-1" />
                      </button>
                    </div>
                  </form>
                </fieldset>
              )}
              {currentStep === 5 && (
                <fieldset style={{ display: "block" }}>
                  <form>
                    <div className="filterbox p-20 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <h4 className="d-flex align-items-center">
                        <i className="ti ti-id text-secondary me-2" />
                        Damages
                      </h4>
                      <div className="dropdown flag-dropdown">
                        <Link
                          className="dropdown-toggle btn btn-white d-flex align-items-center justify-content-between"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          <ImageWithBasePath
                            src="assets/admin/img/flags/gb.svg"
                            alt="Language"
                            className="img-fluid me-1"
                          />
                          English
                        </Link>
                        <ul className="dropdown-menu p-2">
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item d-flex align-items-center"
                            >
                              <ImageWithBasePath
                                src="assets/admin/img/flags/gb.svg"
                                alt=""
                                height={16}
                                className="me-1"
                              />
                              English
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item d-flex align-items-center"
                            >
                              <ImageWithBasePath
                                src="assets/admin/img/flags/sa.svg"
                                alt=""
                                height={16}
                                className="me-1"
                              />
                              Arabic
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="border-bottom mb-2 pb-4">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          <h6 className="mb-1">Damages</h6>
                          <p>Add Damages On Car</p>
                        </div>
                        <div className="col-xl-9">
                          <Link
                            to="#"
                            className="btn btn-dark btn-md d-inline-flex align-items-center mb-3"
                            data-bs-toggle="modal"
                            data-bs-target="#add-damage"
                          >
                            <i className="ti ti-plus me-1" />
                            Add Damage
                          </Link>
                          <div className="card border-0 bg-light mb-0">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
                                <h6>Total Damages : 04</h6>
                                <div className="dropdown flag-dropdown">
                                  <Link
                                    className="dropdown-toggle btn btn-white d-flex align-items-center justify-content-between"
                                    data-bs-toggle="dropdown"
                                    to="#"
                                  >
                                    All Damages
                                  </Link>
                                  <ul className="dropdown-menu p-2">
                                    <li>
                                      <Link
                                        to="#"
                                        className="dropdown-item d-flex align-items-center"
                                      >
                                        All Damages
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to="#"
                                        className="dropdown-item d-flex align-items-center"
                                      >
                                        Interior
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to="#"
                                        className="dropdown-item d-flex align-items-center"
                                      >
                                        Exterior
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="bg-white p-20 br-5 border mb-2">
                                <div className="row align-items-center row-gap-3">
                                  <div className="col-xxl-8 col-md-7">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <h6 className="fs-14 fw-medium">
                                        Scratch
                                      </h6>
                                      <span className="badge bg-pink-transparent badge-sm">
                                        Interior
                                      </span>
                                    </div>
                                    <p className="fs-13">
                                      Minor surface marks, often from keys,
                                      branches, or road debris.
                                    </p>
                                  </div>
                                  <div className="col-xxl-4 col-md-5">
                                    <div className="d-flex align-items-center justify-content-md-end gap-2 flex-wrap">
                                      <p className="mb-0">
                                        Added on : 15 Jan 2025
                                      </p>
                                      <div className="icon-list d-flex align-items-center">
                                        <Link
                                          to="#"
                                          className="edit-icon me-2"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit-damage"
                                        >
                                          <i className="ti ti-edit" />
                                        </Link>
                                        <Link
                                          to="#"
                                          className="trash-icon"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_damage"
                                        >
                                          <i className="ti ti-trash" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="bg-white p-20 br-5 border mb-2">
                                <div className="row align-items-center row-gap-3">
                                  <div className="col-xxl-8 col-md-7">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <h6 className="fs-14 fw-medium">Dent</h6>
                                      <span className="badge bg-secondary-transparent badge-sm">
                                        Exterior
                                      </span>
                                    </div>
                                    <p className="fs-13">
                                      Cracks, scratches, or faded surfaces due
                                      to heat exposure.
                                    </p>
                                  </div>
                                  <div className="col-xxl-4 col-md-5">
                                    <div className="d-flex align-items-center justify-content-md-end gap-2 flex-wrap">
                                      <p className="mb-0">
                                        Added on : 15 Jan 2025
                                      </p>
                                      <div className="icon-list d-flex align-items-center">
                                        <Link
                                          to="#"
                                          className="edit-icon me-2"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit-damage"
                                        >
                                          <i className="ti ti-edit" />
                                        </Link>
                                        <Link
                                          to="#"
                                          className="trash-icon"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_damage"
                                        >
                                          <i className="ti ti-trash" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="bg-white p-20 br-5 border mb-2">
                                <div className="row align-items-center row-gap-3">
                                  <div className="col-xxl-8 col-md-7">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <h6 className="fs-14 fw-medium">Crack</h6>
                                      <span className="badge bg-pink-transparent badge-sm">
                                        Interior
                                      </span>
                                    </div>
                                    <p className="fs-13">
                                      Seats, door panels, or carpets with
                                      stains, rips, or burns.
                                    </p>
                                  </div>
                                  <div className="col-xxl-4 col-md-5">
                                    <div className="d-flex align-items-center justify-content-md-end gap-2 flex-wrap">
                                      <p className="mb-0">
                                        Added on : 15 Jan 2025
                                      </p>
                                      <div className="icon-list d-flex align-items-center">
                                        <Link
                                          to="#"
                                          className="edit-icon me-2"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit-damage"
                                        >
                                          <i className="ti ti-edit" />
                                        </Link>
                                        <Link
                                          to="#"
                                          className="trash-icon"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_damage"
                                        >
                                          <i className="ti ti-trash" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="bg-white p-20 br-5 border mb-0">
                                <div className="row align-items-center row-gap-3">
                                  <div className="col-xxl-8 col-md-7">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <h6 className="fs-14 fw-medium">Clip</h6>
                                      <span className="badge bg-pink-transparent badge-sm">
                                        Interior
                                      </span>
                                    </div>
                                    <p className="fs-13">
                                      Non-functional windows, AC, or
                                      infotainment system damage.
                                    </p>
                                  </div>
                                  <div className="col-xxl-4 col-md-5">
                                    <div className="d-flex align-items-center justify-content-md-end gap-2 flex-wrap">
                                      <p className="mb-0">
                                        Added on : 15 Jan 2025
                                      </p>
                                      <div className="icon-list d-flex align-items-center">
                                        <Link
                                          to="#"
                                          className="edit-icon me-2"
                                          data-bs-toggle="modal"
                                          data-bs-target="#edit-damage"
                                        >
                                          <i className="ti ti-edit" />
                                        </Link>
                                        <Link
                                          to="#"
                                          className="trash-icon"
                                          data-bs-toggle="modal"
                                          data-bs-target="#delete_damage"
                                        >
                                          <i className="ti ti-trash" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end pt-3">
                      <button
                        type="button"
                        onClick={handlePrev}
                        className="btn btn-outline-light border wizard-prev me-2"
                      >
                        <i className="ti ti-chevron-left me-1" />
                        Back
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success wizard-next d-flex align-items-center me-2"
                      >
                        Save
                        <i className="ti ti-save me-1" />
                      </button>
                      <button
                        type="button"
                        onClick={handleNext}
                        className="btn btn-primary wizard-next d-flex align-items-center"
                      >
                        Add Faq
                        <i className="ti ti-chevron-right ms-1" />
                      </button>
                    </div>
                  </form>
                </fieldset>
              )}
              {currentStep === 6 && (
                <fieldset style={{ display: "block" }}>
                  <form>
                    <div className="filterbox p-20 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <h4 className="d-flex align-items-center">
                        <i className="ti ti-question-mark text-secondary me-2" />
                        FAQ
                      </h4>
                    </div>
                    <div className="border-bottom mb-2 pb-4">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          <h6 className="mb-1">FAQ</h6>
                          <p>Add FAQ of your Car</p>
                        </div>
                        <div className="col-xl-9">
                          <Link
                            to="#"
                            className="btn btn-dark btn-md d-inline-flex align-items-center mb-3"
                            data-bs-toggle="modal"
                            data-bs-target="#add-faq"
                          >
                            <i className="ti ti-plus me-1" />
                            Add FAQ
                          </Link>
                          <div className="card border-0 bg-light mb-0">
                            <div className="card-body">
                              <h6 className="mb-3">Total FAQ : 04</h6>
                              <div
                                className="custom-accordion-icon"
                                id="faqaccordion"
                              >
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#faq-one"
                                      aria-expanded="false"
                                      aria-controls="faq-one"
                                    >
                                      <span className="faq-icon">
                                        <i className="ti ti-grip-vertical" />
                                      </span>
                                      What are the requirements to rent a car?
                                    </button>
                                  </h2>
                                  <div
                                    id="faq-one"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#faqaccordion"
                                  >
                                    <div className="accordion-body">
                                      <p className="fs-13">
                                        You must be at least 21 years old, have
                                        a valid driver’s license, and a credit
                                        card for payment.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#faq-two"
                                      aria-expanded="false"
                                      aria-controls="faq-two"
                                    >
                                      <span className="faq-icon">
                                        <i className="ti ti-grip-vertical" />
                                      </span>
                                      What are the requirements to rent a car?
                                    </button>
                                  </h2>
                                  <div
                                    id="faq-two"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#faqaccordion"
                                  >
                                    <div className="accordion-body">
                                      <p className="fs-13">
                                        You must be at least 21 years old, have
                                        a valid driver’s license, and a credit
                                        card for payment.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#faq-three"
                                      aria-expanded="false"
                                      aria-controls="faq-three"
                                    >
                                      <span className="faq-icon">
                                        <i className="ti ti-grip-vertical" />
                                      </span>
                                      What are the requirements to rent a car?
                                    </button>
                                  </h2>
                                  <div
                                    id="faq-three"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#faqaccordion"
                                  >
                                    <div className="accordion-body">
                                      <p className="fs-13">
                                        You must be at least 21 years old, have
                                        a valid driver’s license, and a credit
                                        card for payment.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#faq-four"
                                      aria-expanded="false"
                                      aria-controls="faq-four"
                                    >
                                      <span className="faq-icon">
                                        <i className="ti ti-grip-vertical" />
                                      </span>
                                      What are the requirements to rent a car?
                                    </button>
                                  </h2>
                                  <div
                                    id="faq-four"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#faqaccordion"
                                  >
                                    <div className="accordion-body">
                                      <p className="fs-13">
                                        You must be at least 21 years old, have
                                        a valid driver’s license, and a credit
                                        card for payment.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end pt-3">
                      <button
                        type="button"
                        onClick={handlePrev}
                        className="btn btn-outline-light border wizard-prev me-2"
                      >
                        <i className="ti ti-chevron-left me-1" />
                        Back
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success wizard-next d-flex align-items-center me-2"
                      >
                        Save
                        <i className="ti ti-save me-1" />
                      </button>
                      <button
                        type="button"
                        onClick={handleNext}
                        className="btn btn-primary wizard-next d-flex align-items-center"
                      >
                        Add Seo
                        <i className="ti ti-chevron-right ms-1" />
                      </button>
                    </div>
                  </form>
                </fieldset>
              )}
              {currentStep === 7 && (
                <fieldset style={{ display: "block" }}>
                  <form
                    onSubmit={async(e) => {
                      await saveCarData(e);
                    }}
                  >
                    <div className="filterbox p-20 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <h4 className="d-flex align-items-center">
                        <i className="ti ti-question-mark text-secondary me-2" />
                        SEO
                      </h4>
                      <div className="dropdown flag-dropdown">
                        <Link
                          className="dropdown-toggle btn btn-white d-flex align-items-center justify-content-between"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          <ImageWithBasePath
                            src="assets/admin/img/flags/gb.svg"
                            alt="Language"
                            className="img-fluid me-1"
                          />
                          English
                        </Link>
                        <ul className="dropdown-menu p-2">
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item d-flex align-items-center"
                            >
                              <ImageWithBasePath
                                src="assets/admin/img/flags/gb.svg"
                                alt=""
                                height={16}
                                className="me-1"
                              />
                              English
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item d-flex align-items-center"
                            >
                              <ImageWithBasePath
                                src="assets/admin/img/flags/sa.svg"
                                alt=""
                                height={16}
                                className="me-1"
                              />
                              Arabic
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="border-bottom mb-2 pb-2">
                      <div className="row row-gap-4">
                        <div className="col-xl-3">
                          <h6 className="mb-1">SEO</h6>
                          <p>Add SEO Meta of the car</p>
                        </div>
                        <div className="col-xl-9">
                          <div className="mb-3">
                            <label className="form-label">
                              Meta Title <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Keywords <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Description <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              defaultValue={""}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end pt-3">
                      <button
                        type="button"
                        onClick={handlePrev}
                        className="btn btn-outline-light border wizard-prev me-2"
                      >
                        <i className="ti ti-chevron-left me-1" />
                        Back
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success d-flex align-items-center me-2"
                      >
                        Save
                      </button>
                      <button
                        type="submit"
                        className="btn btn-warning d-flex align-items-center"
                         onClick={() => {
                            setFormData({ ...formData, exit: true });
                          }}
                      >
                        Save & Exit
                        <i className="ti ti-chevron-right me-1" />
                      </button>
                    </div>
                  </form>
                </fieldset>
              )}
            </div>
          </div>
        </div>
      </div>
      <VideoModal
        show={showModal}
        handleClose={handleCloseModal}
        videoUrl={videoUrl}
      />
      <CarBookingModal />
    </>
  );
};

AddCarForm.propTypes = {
  carData: PropTypes.any, // or PropTypes.string if not required
  formData: PropTypes.any,
  setFormData: PropTypes.any,
  defaultFormData: PropTypes.any,
  message: PropTypes.any,
  setMessage: PropTypes.any,
  filtersCars: PropTypes.any,
};

export default AddCarForm;
